/** @jsxImportSource solid-js */

import Modal from "@lutaok/solid-modal";
import { customElement, noShadowDOM } from "solid-element";
import {
  createEffect,
  createSignal,
  type ValidComponent,
  createMemo,
  Show,
} from "solid-js";
import { Dynamic } from "solid-js/web";
import { PrimaryButton } from "#palette/components/button.solid";
import {
  AmpersandsConsentPage,
  shouldShowAmpersandsPage,
} from "./ampersandsConsent.solid";
import {
  AcceptPrivacyPolicyPage,
  shouldShowPrivacyPolicyPage,
} from "./privacyPolicy.solid";

// TODO: are these sub-paginated?
// TODO: demographics update
// TODO: recovery update

function StartPage(props: { goNext: () => void }) {
  return (
    <>
      <h1 class="text-xl font-bold">It's been a while since you logged in!</h1>
      <p>
        Thank you for coming back. There are some settings we need you to
        update, and consent we need to ask for before you go:
      </p>

      <div class="flex items-center justify-between mt-4">
        <div></div>
        <span>
          <PrimaryButton onClick={props.goNext}>Get Started</PrimaryButton>
        </span>
      </div>
    </>
  );
}

export function LongtimeNoSeeModal() {
  const [currentPage, setCurrentPage] = createSignal(0);
  const [pages, setPages] = createSignal<ValidComponent[]>([]);
  const [isOpen, setIsOpen] = createSignal(false);

  // We need to compute what "pages" to show in the modal at creation time.
  createEffect(async () => {
    const p = [];

    if (await shouldShowAmpersandsPage()) {
      p.push(AmpersandsConsentPage);
    }

    if (await shouldShowPrivacyPolicyPage()) {
      p.push(AcceptPrivacyPolicyPage);
    }

    if (p.length > 0) {
      setPages([StartPage, ...p]);
      setIsOpen(true);
    }
  });

  // Close the modal automatically if the user goes to the last page.
  createEffect(() => {
    if (currentPage() === pages().length) {
      setIsOpen(false);
    }
  });

  const selectedPage = createMemo(() => {
    const p = pages().at(currentPage());
    return p;
  });

  return (
    <Modal
      isOpen={isOpen()}
      onCloseRequest={() => {}}
      closeOnOutsideClick={false}
      overlayClass="bg-brand-900/20 fixed top-0 left-0 grid w-screen h-screen z-50"
      contentClass="rounded-lg p-5 flex flex-col gap-2 bg-white border border-brand-500 shadow content-start place-self-center max-w-xl"
    >
      <Dynamic
        component={selectedPage()}
        goNext={() => {
          setCurrentPage(currentPage() + 1);
        }}
      />
    </Modal>
  );
}

customElement("long-time-no-see-modal", () => {
  noShadowDOM();

  return <LongtimeNoSeeModal />;
});
